import './Statement.scss';

// The "what". This sentence used to be the Process header, three sections down,
// stapled to three cards about workflow — so the one line on the page that says
// what this company is was doing its work in a slot that answers "how". A cold
// visitor met the hero, then an argument for video in general, and never got a
// plain statement of the business in between.
//
// It sits on the same $black field as Impact directly below, with no seam
// between them: the dark region is now the whole opening argument — what this
// is, then why it's worth doing — and the page still breaks into white at
// Process, which is where "how" belongs.
function Statement() {
    return (
        <div className="Statement" id="what">
            <div className="Statement-container reveal">
                <span className="Statement-eyebrow">What we do</span>

                <h2 className="Statement-header">
                    A Minneapolis video production service designed to{" "}
                    <span>communicate your mission through film.</span>
                </h2>

                <p className="Statement-lead">
                    Parishes, nonprofits, and the businesses that stand behind them.
                    We write it, shoot it, and cut it — you get one finished film,
                    for the event, the campaign page, and the email that has to do
                    the asking.
                </p>

                {/* the turn into Impact: naming what the rest of the page is for,
                    so the "why" arrives as an answer to something rather than as
                    an argument nobody asked for yet */}
                <p className="Statement-hinge">
                    What follows is why that's worth doing, and what it looks like
                    when it's done.
                </p>
            </div>
        </div>
    );
}

export default Statement;
